import React, { useMemo } from 'react';
import { type I18nLocale, t } from '@ardoq/i18n';
import { Locale } from '@ardoq/locale';
import { Navigator } from '../components/Navigator';
import { LoadDataError } from '../components/LoadDataError';
import { LoadDataNotification } from '../components/LoadDataNotification';
import { getSelectContextConfiguration } from './selectContextConfiguration';

type SelectContextRootProps = {
  i18nLocale: I18nLocale;
  locale: Locale;
};

const SelectContextRoot = React.memo(
  ({ i18nLocale, locale }: SelectContextRootProps) => {
    const navigatorConfiguration = useMemo(
      () => ({
        ...getSelectContextConfiguration(locale),
        name: t(
          i18nLocale,
          'componentHierarchies:contextSelector.selectContextComponents',
          'Select context components'
        ),
        i18nLocale,
        locale,
      }),
      [i18nLocale, locale]
    );
    return (
      <Navigator
        navigatorConfiguration={navigatorConfiguration}
        LoadDataError={LoadDataError}
        LoadDataNotification={LoadDataNotification}
      />
    );
  }
);

export { SelectContextRoot };
